import type {ShiftQuickSelectSlots, ExtendedShiftQuickSelectSlots} from '@hconnect/common/types'

export type KpiFormFields = {
  actualValue?: number
  plannedValue?: number
}

export type KpiFormData = Record<
  string, // ProcessStage
  Record<
    string, // Name
    KpiFormFields
  >
>

// Due to performance reasons for selected slot we only ask for one time frame which comes from RTC
// time frames from RTC: currentShift, pastShift, shiftBeforePastShift, today, yesterday, theDayBeforeYesterday, last24hours
// time frames from CCE: lastWeekend, theWeekendBeforeLast, last3days, last7days, last30days, lastMonth, monthBeforeLastMonth
export const QuickSelectSlotsForSlotMap: Record<
  ShiftQuickSelectSlots,
  ExtendedShiftQuickSelectSlots[]
> = {
  currentShift: ['currentShift', 'last7days'],
  pastShift: ['pastShift', 'last7days'],
  today: ['today', 'last7days'],
  last24hours: ['last24hours', 'last7days'],
  yesterday: ['yesterday', 'last7days'],
  lastWeekend: ['lastWeekend', 'theWeekendBeforeLast', 'last7days'],
  last3days: ['last3days', 'last7days', 'lastMonth'],
  last7days: ['last7days', 'lastMonth'],
  last30days: ['last30days', 'lastMonth', 'monthBeforeLastMonth'],
  next30days: [],
  rolling12months: []
}
